import React from 'react';
import {withSnackbar} from "notistack";
import "./Modal.css"
import Utils from  '../../utils/utils'
import Cookies from "js-cookie";

import {
    Modal,
} from 'react-bootstrap';

import PartnerApi from "../../services/ob-user/partner";

class ModalAddPartner extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name:'',
            phone:'',
            email:'',
            repassword:'',
            signupInfo: null,
            nameErr: false,
            phoneErr: false,
            emailErr: false,

            btnStatus: false,
        };
    }
    componentDidMount() {
        this.setState({
            name:'',
            phone:'',
            email:'',
            password:'',
            repassword:'',
            nameErr: false,
            phoneErr: false,
            emailErr: false,
            passwordErr: false,
            rePasswordErr: false,
            btnStatus: false,
        });
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps.show){
            this.setState({
                name:'',
                phone:'',
                email:'',
                password:'',
                repassword:'',
                nameErr: false,
                passwordErr: false,
                rePasswordErr: false,
                phoneErr: false,
                emailErr: false,
                btnStatus: false,
            });
        }
    }

    onSubmit =()=>{
        if(this.state.name.length  == 0 && this.state.phone.length == 0 && this.state.email.length == 0 && this.state.password.length == 0  && this.state.repassword.length == 0 ){
            this.setState({
                nameErr: true,
                phoneErr: true,
                emailErr: true,
                passwordErr: true,
                rePasswordErr: true,});
            this.props.enqueueSnackbar('Không được để trống thông tin !', {
                variant: 'error',
            });
        }else if(this.state.name.length  == 0 ){
            this.setState({nameErr: true});
            this.props.enqueueSnackbar('Không được để trống họ và tên !', {
                variant: 'error',
            });
        }else if(this.state.phone.length <10 || this.state.phone.length == 0){
            this.setState({phoneErr: true});
            this.props.enqueueSnackbar('Số điện thoại sai định dạng hoặc đang để trống !', {
                variant: 'error',
            });
        }else if(this.state.email.length == 0 ){
            this.setState({emailErr: true});
            this.props.enqueueSnackbar('Email đang để trống !', {
                variant: 'error',
            });
        } else if (this.state.password.length < 6) {
            this.setState({
                passwordErr: true,
            })
            this.props.enqueueSnackbar('Mật khẩu không được nhỏ hơn 6 kí tự !', {
                variant: 'error',
            })
        } else if (this.state.password != this.state.repassword) {
            this.setState({
                rePasswordErr: true,
            })
            this.props.enqueueSnackbar('Nhập lại mật khẩu chưa chính xác !', {
                variant: 'error',
            });
        } else {
            this.addAccountant()
        }
    }

    addAccountant = () => {
        let payload = {
            email: this.state.email.toLowerCase(),
            fullName: this.state.name,
            password: this.state.password,
            phone: this.state.phone
        }
        PartnerApi.adminObCreatePartner(payload, res => {
            if (res.errorCode == "One-Book-Auth.E000003") {
                this.props.enqueueSnackbar(res.message[0], {
                    variant: 'error',
                });
            }
            else if (res.success) {
                this.props.enqueueSnackbar('Tạo mới partner thành công !', {
                    variant: 'success',
                });

                this.props.onHide();
                this.props.onRefresh();
            }
            else  {
                return this.props.enqueueSnackbar('Tạo mới không thành công, vui lòng thử lại !', {
                    anchorOrigin: {
                        vertical: "top",
                        horizontal: "right"
                    },
                    variant: 'error',
                });
            }
        })
    }


    render() {
        const modalProp = {
            show: this.props.show,
            onHideModal: this.props.onHideModal,
            keyboard: false,
            backdrop: 'static',
        };
        return (
            <div>
                <Modal {...modalProp} dialogClassName="modal-dialog-centered">
                    <div className="btn-close">
                        <button type="button" className="close" onClick={this.props.onHide}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <Modal.Body>
                        <div className="modal-container">

                        </div>
                        <div>
                            <h1 className="text-center" style={{fontSize:20,}}><b>THÊM MỚI PARTNER</b></h1>
                        </div>

                        <div>
                            <div className="row">
                                <label className="col-6 mt-2">Tên công ty </label>
                                <input
                                    className={this.state.nameErr?"inputPassword w-100 col-6 border-input-error":"inputPassword w-100 col-6"}
                                    placeholder="Nhập vào họ tên"
                                    maxLength={100}
                                    value={this.state.name}
                                    onChange={(e) => this.setState({name: e.target.value.trimLeft()
                                        },
                                        () =>{
                                            this.state.name.length == 0 ? this.setState({nameErr: true, btnStatus: true}): this.setState({nameErr: false, btnStatus: false})
                                        }
                                    )}
                                />
                            </div>
                            {this.state.nameErr?<div className="row">
                                <label className="col-6 "></label>
                                <label className="col-6 font-err">Tên công ty đang để trống !</label>
                            </div>:<div/>}

                            <div className={this.state.phoneErr?"row mt-2":"row mt-3"}>
                                <label className="col-6 mt-2">Số điện thoại </label>
                                <input
                                    className={this.state.phoneErr?"inputPassword w-100 col-6 border-input-error":"inputPassword w-100 col-6 "}
                                    placeholder="Nhập vào SĐT"
                                    fullWidth
                                    maxLength={11}
                                    value={this.state.phone}
                                    onChange={(e) => this.setState({phone: e.target.value.trim().replace(/[^0-9]/g, '')},
                                        () =>{
                                            this.state.phone.length <10 ? this.setState({phoneErr: true, btnStatus: true}): this.setState({phoneErr: false, btnStatus: false})
                                        }

                                    )}
                                />
                            </div>
                            {this.state.phoneErr?<div className="row">
                                <label className="col-6 "></label>
                                <label className="col-6 font-err">SĐT không đúng hoặc đang để trống !</label>
                            </div>:<div/>}

                            <div className={this.state.emailErr?"row mt-2":"row mt-3"}>
                                <label className="col-6 mt-2">Email</label>
                                <input
                                    // type="email"
                                    maxLength={50}
                                    className={this.state.emailErr?"inputPassword w-100 col-6 border-input-error ":"inputPassword w-100 col-6 "}
                                    placeholder='Nhập Email'
                                    fullWidth
                                    // value={this.state.email}
                                    // onChange={(e) => this.setState({email: e.target.value.trim()},
                                    //     () =>{
                                    //         console.log('CHECKEMAIL>>>>>>',this.state.email);
                                    //         this.state.email.length == 0 ? this.setState({emailErr: true, btnStatus: true}): this.setState({emailErr: false, btnStatus: false})
                                    //     })}
                                    onChange={(e)=> {
                                        if (Utils.checkEmailRegex(e.target.value.trim())){
                                            // khoong dudng dinh dang
                                            this.setState({emailErr: true, btnStatus: true})
                                        }else{
                                            this.setState({email: e.target.value.trim(),emailErr: false, btnStatus: false})
                                        }
                                    }}
                                />
                            </div>
                            {this.state.emailErr?<div className="row">
                                <label className="col-6 "></label>
                                <label className="col-6 font-err">Email không đúng hoặc đang để trống !</label>
                            </div>:<div/>}

                            <div className={this.state.contarctErr?"row mt-2":"row mt-3"}>
                                <label className="col-6 mt-2">Mật khẩu</label>
                                <input
                                    className={this.state.passwordErr?"inputPassword w-100 col-6 border-input-error":"inputPassword w-100 col-6"}
                                    placeholder='Mật khẩu'
                                    fullWidth
                                    security={true}
                                    maxLength={20}
                                    minLength={6}
                                    value={this.state.password}
                                    onChange={(e) => this.setState({password: e.target.value.trim()},
                                        () =>{
                                            this.state.password.length == 0
                                            ? this.setState({passwordErr: true, btnStatus: true}): this.setState({passwordErr: false, btnStatus: false})
                                        })}
                                />
                            </div>
                            {this.state.passwordErr?<div className="row">
                                <label className="col-6 "></label>
                                <label className="col-6 font-err">Mật khẩu đang để trống !</label>
                            </div>:''}

                            <div className={this.state.contarctErr?"row mt-2":"row mt-3"}>
                                <label className="col-6 mt-2">Xác nhận mật khẩu</label>
                                <input
                                    className={this.state.passwordErr?"inputPassword w-100 col-6 border-input-error":"inputPassword w-100 col-6"}
                                    placeholder='Xác nhận mật khẩu'
                                    fullWidth
                                    maxLength={20}
                                    minLength={6}
                                    value={this.state.repassword}
                                    onChange={(e) => this.setState({repassword: e.target.value.trim()},
                                        () =>{
                                            this.state.password.length == 0
                                            ? this.setState({rePasswordErr: true, btnStatus: true}): this.setState({rePasswordErr: false, btnStatus: false})
                                        })}
                                />
                            </div>
                            {this.state.rePasswordErr?<div className="row">
                                <label className="col-6 "></label>
                                <label className="col-6 font-err">Mật khẩu không đúng không đúng hoặc đang để trống !</label>
                            </div>:''}
                        </div>

                        <div container item xs={12} >
                            <div item xs={12}>
                                <div className="align-center mt-3 mb-2">
                                    <button
                                        type="button"
                                        className="ml-4 col-3 border-1-s background-btn w-75 type-button-fix btn btn-primary"
                                        disabled={this.state.btnStatus}
                                        onClick={this.onSubmit}
                                    >
                                        <span className='d-flex justify-content-center'>
                                         Đồng ý
                                        </span>
                                    </button>
                                    <button
                                        type="button"
                                        className="ml-4 col-3 border-1-s w-50 type-button-fix btn btn-light"
                                        // disabled={this.state.oldpassword?.length == 0 || this.state.newpassword?.length == 0 || this.state.repassword?.length == 0 }
                                        onClick={this.props.onHide}
                                    >
                                        <span className='d-flex justify-content-center'>
                                            Hủy
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}


export default withSnackbar(ModalAddPartner);
